














import { Component, Prop, Vue } from 'vue-property-decorator'
import { Icon } from '@alpha/ink'

@Component({
  components: { Icon }
})
export default class SavedFilter extends Vue {
  @Prop({ required: true }) readonly keywords!: string[]
  @Prop({ required: true }) readonly idx!: number
  @Prop({ required: true }) readonly isChecked!: boolean

  showDeleteIcon: boolean = false

  toggleDelete () {
    this.showDeleteIcon = !this.showDeleteIcon
  }

  selectFilter (idx: number) {
    this.$emit('updateToucan', {
      type: 'selectFilter',
      index: idx
    })
  }

  deleteSavedFilter (idx: number) {
    this.$emit('updateToucan', {
      type: 'deleteSavedFilter',
      index: idx
    })
  }
}
